import { ComponentBase } from "../../core/ComponentBase.js";
import { avatarHelper } from "../../helpers/avatarHelper.js";

function avatarColor(str) {
    const palette = ['#3B82F6','#10B981','#F59E0B','#EF4444','#8B5CF6','#06B6D4','#F97316','#14B8A6','#EC4899','#6366F1'];
    let h = 0;
    for (let i = 0; i < (str||'').length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
    return palette[Math.abs(h) % palette.length];
}
function initials(name) {
    const p = (name || '?').trim().split(/\s+/);
    return p.length >= 2 ? (p[0][0] + p[p.length-1][0]).toUpperCase() : (name||'?').slice(0,2).toUpperCase();
}

export class ThreadInfoPanel extends ComponentBase {
    static styles = `
        .ws-tip {
            position: absolute; top: 0; right: 0; bottom: 0; width: 300px; max-width: 85%;
            background: var(--bs-body-bg);
            border-left: 1px solid var(--bs-border-color-translucent);
            z-index: var(--ab-z-toast); display: flex; flex-direction: column;
            transform: translateX(100%);
            transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), visibility 0.25s;
            box-shadow: -4px 0 20px rgba(0,0,0,0.15);
            visibility: hidden;
        }
        .ws-tip-backdrop {
            position: absolute; inset: 0; background: transparent;
            z-index: 1999;
        }
        .ws-tip.open { transform: translateX(0); visibility: visible; }
        .ws-tip-header {
            display: flex; align-items: center; gap: 0.6rem;
            padding: 0.75rem 1rem; border-bottom: 1px solid var(--bs-border-color-translucent);
            flex-shrink: 0;
        }
        .ws-tip-close {
            width: 30px; height: 30px; border-radius: 50%; border: none;
            background: transparent; color: var(--bs-secondary-color);
            cursor: pointer; display: flex; align-items: center; justify-content: center;
            font-size: var(--ab-text-base); transition: background 0.15s; flex-shrink: 0;
        }
        .ws-tip-close:hover { background: var(--bs-secondary-bg); color: var(--bs-body-color); }
        .ws-tip-title { font-weight: 600; font-size: var(--ab-text-base); }
        .ws-tip-body { flex-grow: 1; overflow-y: auto; padding: 0; }

        /* Identity section */
        .ws-tip-identity {
            display: flex; flex-direction: column; align-items: center;
            gap: 0.4rem; padding: 1.25rem 1rem;
            border-bottom: 1px solid var(--bs-border-color-translucent);
        }
        .ws-tip-avatar {
            width: 64px; height: 64px; border-radius: 50%;
            display: flex; align-items: center; justify-content: center;
            font-size: var(--ab-text-lg); font-weight: 700; color: #fff;
            flex-shrink: 0;
        }
        .ws-tip-name { font-size: var(--ab-text-md); font-weight: 700; text-align: center; }
        .ws-tip-badge {
            font-size: var(--ab-text-2xs); padding: 0.15rem 0.5rem; border-radius: var(--ab-radius-xl);
            background: rgba(var(--bs-primary-rgb),0.1); color: var(--bs-primary);
            font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em;
        }

        /* Sections */
        .ws-tip-section { padding: 0.75rem 1rem; border-bottom: 1px solid var(--bs-border-color-translucent); }
        .ws-tip-section-title {
            font-size: var(--ab-text-2xs); font-weight: 700; letter-spacing: 0.1em;
            text-transform: uppercase; color: var(--bs-secondary-color);
            margin-bottom: 0.6rem;
        }
        .ws-tip-setting { margin-bottom: 0.6rem; }
        .ws-tip-setting label { font-size: var(--ab-text-xs); font-weight: 600; margin-bottom: 0.25rem; display: block; color: var(--bs-body-color); }
        .ws-tip-input {
            width: 100%; padding: 0.4rem 0.6rem; border-radius: var(--ab-radius-md);
            border: 1px solid var(--bs-border-color); background: var(--bs-tertiary-bg);
            color: var(--bs-body-color); font-size: var(--ab-text-sm); outline: none;
            transition: border-color 0.15s;
        }
        .ws-tip-input:focus { border-color: var(--bs-primary); }

        /* Member rows */
        .ws-tip-member {
            display: flex; align-items: center; gap: 0.55rem;
            padding: 0.4rem 0; border-radius: var(--ab-radius-sm);
        }
        .ws-tip-member-av {
            width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
            display: flex; align-items: center; justify-content: center;
            font-size: var(--ab-text-xs); font-weight: 600; color: #fff;
        }
        .ws-tip-member-info { flex-grow: 1; min-width: 0; }
        .ws-tip-member-name { font-size: var(--ab-text-sm); font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .ws-tip-member-sub { font-size: var(--ab-text-2xs); color: var(--bs-secondary-color); }
        .ws-tip-rm {
            width: 26px; height: 26px; border-radius: 50%; border: none;
            background: transparent; color: var(--bs-secondary-color);
            cursor: pointer; display: flex; align-items: center; justify-content: center;
            font-size: var(--ab-text-xs); opacity: 0; transition: opacity 0.12s, background 0.12s;
        }
        .ws-tip-member:hover .ws-tip-rm { opacity: 1; }
        .ws-tip-rm:hover { background: rgba(var(--bs-danger-rgb),0.1); color: var(--bs-danger); }
        .ws-tip-add {
            width: 100%; padding: 0.45rem; border-radius: var(--ab-radius-md); margin-top: 0.4rem;
            border: 1px dashed var(--bs-border-color); background: transparent;
            color: var(--bs-secondary-color); cursor: pointer; font-size: var(--ab-text-sm);
            display: flex; align-items: center; justify-content: center; gap: 0.4rem;
            transition: border-color 0.15s, color 0.15s, background 0.15s;
        }
        .ws-tip-add:hover { border-color: var(--bs-primary); color: var(--bs-primary); background: rgba(var(--bs-primary-rgb),0.04); }

        /* Danger */
        .ws-tip-danger { padding: 0.75rem 1rem; }
        .ws-tip-danger-btn {
            width: 100%; padding: 0.45rem; border-radius: var(--ab-radius-md);
            border: 1px solid rgba(var(--bs-danger-rgb),0.3); background: transparent;
            color: var(--bs-danger); cursor: pointer; font-size: var(--ab-text-sm);
            display: flex; align-items: center; justify-content: center; gap: 0.4rem;
            transition: background 0.15s;
        }
        .ws-tip-danger-btn:hover { background: rgba(var(--bs-danger-rgb),0.08); }
    `;

    constructor(config) {
        super(config);
        this.workspace = config.workspace;
        this.thread = null;
        this.isOpen = false;
        this.onAddMember = config.onAddMember || null;
        this.applyStyles();
    }

    async render(parentContainer) {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'ws-tip';
            parentContainer.appendChild(this.container);
        }
        return this.container;
    }

    open(thread) {
        if (thread) this.thread = thread;
        this.isOpen = true;
        this._renderContent();
        requestAnimationFrame(() => {
            this.container?.classList.add('open');
            // Add backdrop
            if (!this._backdrop && this.container?.parentElement) {
                this._backdrop = document.createElement('div');
                this._backdrop.className = 'ws-tip-backdrop';
                this._backdrop.addEventListener('click', () => this.close());
                this.container.parentElement.appendChild(this._backdrop);
            }
        });
    }

    close() {
        this.isOpen = false;
        this.container?.classList.remove('open');
        this._backdrop?.remove();
        this._backdrop = null;
    }

    toggle(thread) { this.isOpen ? this.close() : this.open(thread); }

    setThread(thread) {
        this.thread = thread;
        if (this.isOpen) this._renderContent();
    }

    // Resolve display name — checks member fields, then RDS users cache, then agent config
    _resolveName(m) {
        // 1. If displayName is already a real name (not the raw ID)
        if (m.displayName && m.displayName !== m.participantId) return m.displayName;

        if (m.participantType === 'agent') {
            const agent = this.workspace.agents?.find(a => a._id === m.participantId || a.name === m.participantId);
            return agent?.name || m.participantId;
        }

        // 2. For users, look up in RDS 'users' dataset (synchronous Map)
        const rdsMap = this.appClient.rds?.data?.get('users');
        if (rdsMap) {
            const found = rdsMap.get(m.participantId) || rdsMap.get(String(m.participantId));
            if (found) {
                const full = [found.firstName, found.lastName].filter(Boolean).join(' ');
                return full || found.username || found.email || m.participantId;
            }
        }

        // 3. Check if it's the current user
        const me = this.appClient.getSharedData('user');
        if (me && me._id === m.participantId) {
            const full = [me.firstName, me.lastName].filter(Boolean).join(' ');
            return full || me.username || 'You';
        }

        return `User …${m.participantId.slice(-6)}`;
    }


    // Build avatar HTML with img if available, else initials
    _avatarHtml(m, size = 32) {
        const name = this._resolveName(m);
        const isAgent = m.participantType === 'agent';

        // Check for avatarUrl on member, or look up agent config, or look up user profile picture
        let avatarUrl = m.avatarUrl || null;
        if (!avatarUrl) {
            if (isAgent) {
                const agent = this.workspace.agents?.find(a => a._id === m.participantId || a.name === m.participantId);
                avatarUrl = agent?.avatarUrl || null;
            } else {
                // For users, check RDS 'users' dataset
                const rdsMap = this.appClient.rds?.data?.get('users');
                if (rdsMap) {
                    const found = rdsMap.get(m.participantId) || rdsMap.get(String(m.participantId));
                    if (found && found.profilePicture) {
                        avatarUrl = found.profilePicture;
                    }
                }
                // Check if current user
                if (!avatarUrl) {
                    const me = this.appClient.getSharedData('user');
                    if (me && me._id === m.participantId && me.profilePicture) {
                        avatarUrl = me.profilePicture;
                    }
                }
            }
        }

        const avatarEl = avatarHelper.createAvatarElement({
            displayName: name,
            avatarUrl: avatarUrl,
            type: isAgent ? 'agent' : 'user',
            size: size,
            sizeClass: 'default'
        });

        // Ensure we preserve the inline styles needed by the panel
        avatarEl.style.width = `${size}px`;
        avatarEl.style.height = `${size}px`;
        avatarEl.style.borderRadius = '50%';
        avatarEl.style.flexShrink = '0';
        avatarEl.style.display = 'flex';
        avatarEl.style.alignItems = 'center';
        avatarEl.style.justifyContent = 'center';
        avatarEl.style.fontSize = `${size * 0.35}px`;
        avatarEl.style.fontWeight = '600';
        avatarEl.style.color = '#fff';
        avatarEl.style.overflow = 'hidden';

        return avatarEl.outerHTML;
    }

    _renderContent() {
        if (!this.container || !this.thread) return;
        const thread = this.thread;
        const enableParticipants = this.workspace.config?.options?.enableUserParticipants !== false;
        const currentUserId = this.appClient.getSharedData('user')?._id;
        const members = thread.members || [];
        const meAsMember = members.find(m => m.participantId === currentUserId);
        const isOwner = meAsMember?.role === 'owner';
        const isGroup = thread.type === 'group' || thread.type === 'ai_human' || members.length > 2;
        const displayName = (isGroup && thread.groupName) ? thread.groupName : thread.title;
        const bgColor = avatarColor(displayName);
        const avatarLabel = initials(displayName);

        let avatarHtml = `<div class="ws-tip-avatar" style="background:${bgColor};">${avatarLabel}</div>`;
        if (!isGroup) {
            const otherMember = members.find(m => m.participantId !== currentUserId) || members[0];
            if (otherMember) {
                avatarHtml = this._avatarHtml(otherMember, 64);
            }
        }

        this.container.innerHTML = `
            <div class="ws-tip-header" style="display:flex;align-items:center;width:100%;">
                <span class="ws-tip-title" style="flex-grow:1;">Conversation Info</span>
                <button class="ws-tip-close" id="tip-close"><i class="bi bi-x-lg"></i></button>
            </div>
            <div class="ws-tip-body">
                <div class="ws-tip-identity">
                    ${avatarHtml}
                    <div class="ws-tip-name">${this.escapeHtml(displayName)}</div>
                    <span class="ws-tip-badge">${thread.type || 'ai_only'}</span>
                </div>

                ${isGroup && isOwner ? `
                <div class="ws-tip-section">
                    <div class="ws-tip-section-title">Group Settings</div>
                    <div class="ws-tip-setting">
                        <label>Group name</label>
                        <input class="ws-tip-input" id="tip-gname" value="${this.escapeAttr(thread.groupName || thread.title || '')}">
                    </div>
                    <div class="ws-tip-setting">
                        <label>AI Response Mode</label>
                        <select class="ws-tip-input" id="tip-aimode">
                            <option value="always" ${thread.aiResponseMode==='always'?'selected':''}>Always respond</option>
                            <option value="mentioned" ${thread.aiResponseMode==='mentioned'?'selected':''}>Only when @mentioned</option>
                            <option value="manual" ${thread.aiResponseMode==='manual'?'selected':''}>Manual only</option>
                        </select>
                    </div>
                    <button class="btn btn-primary btn-sm w-100 mt-1" id="tip-save">Save Settings</button>
                </div>` : ''}

                ${enableParticipants ? `
                <div class="ws-tip-section">
                    <div class="ws-tip-section-title">${members.length} Participant${members.length!==1?'s':''}</div>
                    <div id="tip-members"></div>
                    ${isOwner ? `<button class="ws-tip-add" id="tip-add"><i class="bi bi-person-plus"></i> Add participant</button>` : ''}
                </div>` : ''}

                <div class="ws-tip-section" id="tip-memory-section" style="display:none;"></div>

                <div class="ws-tip-danger">
                    <button class="ws-tip-danger-btn" id="tip-delete"><i class="bi bi-trash"></i> Delete Conversation</button>
                </div>
            </div>
        `;

        // Render members with resolved names + avatars
        if (enableParticipants) {
            const listEl = this.container.querySelector('#tip-members');
            if (listEl) members.forEach(m => {
                const canRemove = isOwner && m.participantId !== currentUserId && m.role !== 'owner';
                const name = this._resolveName(m);
                const row = document.createElement('div');
                row.className = 'ws-tip-member';
                row.innerHTML = `
                    ${this._avatarHtml(m, 32)}
                    <div class="ws-tip-member-info">
                        <div class="ws-tip-member-name">${this.escapeHtml(name)}</div>
                        <div class="ws-tip-member-sub">${m.participantType} · ${m.role}</div>
                    </div>
                    ${canRemove ? `<button class="ws-tip-rm" title="Remove"><i class="bi bi-person-dash"></i></button>` : ''}
                `;
                if (canRemove) row.querySelector('.ws-tip-rm').addEventListener('click', () => this._removeMember(m));
                listEl.appendChild(row);
            });
        }

        // Wire buttons
        this.container.querySelector('#tip-close').addEventListener('click', () => this.close());
        this.container.querySelector('#tip-save')?.addEventListener('click', () => this._saveSettings());
        this.container.querySelector('#tip-add')?.addEventListener('click', () => { this.close(); this.onAddMember?.(); });
        this.container.querySelector('#tip-delete').addEventListener('click', () => this._deleteThread());

        this._loadMemoryStatus();
    }

    async _loadMemoryStatus() {
        if (!this.thread) return;
        const members = this.thread.members || [];
        const agentMember = members.find(m => m.participantType === 'agent');
        if (!agentMember) return;

        const agent = this.workspace.agents?.find(a => a._id === agentMember.participantId || a.name === agentMember.participantId);
        const agentName = agent?.name || agentMember.participantId;
        if (!agentName) return;

        const container = this.container.querySelector('#tip-memory-section');
        if (!container) return;

        try {
            const status = await this.appClient.rpcClient.call('AiRpc.getMemoryStatus', {
                agentName,
                threadId: this.thread._id
            });

            if (!status || !status.supported) {
                container.style.display = 'none';
                return;
            }

            container.style.display = 'block';
            const percent = Math.min(status.percentUsed || 0, 100);

            const formatTokens = (num) => {
                if (num >= 1000) return (num / 1000).toFixed(1) + 'k';
                return num;
            };

            const progressBarColor = percent > 85 ? 'bg-danger' : (percent > 60 ? 'bg-warning' : 'bg-primary');
            const statusBadge = status.compactionPending
                ? `<span class="badge bg-warning text-dark float-end animate-pulse">Pending Compaction</span>`
                : '';

            const lastCompactedText = status.lastCompactedAt
                ? new Date(status.lastCompactedAt).toLocaleString()
                : this.t('Never');

            container.innerHTML = `
                <div class="ws-tip-section-title d-flex justify-content-between align-items-center">
                    <span>${this.t('Memory & Context')}</span>
                    ${statusBadge}
                </div>
                <div class="mb-3">
                    <div class="d-flex justify-content-between small text-muted mb-1">
                        <span>Usage: ${formatTokens(status.totalEstimatedTokens)} / ${formatTokens(status.threshold)}</span>
                        <span>${percent.toFixed(0)}%</span>
                    </div>
                    <div class="progress" style="height: 6px; border-radius: var(--ab-radius-xs); background-color: var(--bs-secondary-bg);">
                        <div class="progress-bar ${progressBarColor}" role="progressbar" style="width: ${percent}%"></div>
                    </div>
                </div>
                <div class="d-flex justify-content-between small text-muted mb-3">
                    <span>Last Compacted:</span>
                    <span class="fw-medium text-body">${lastCompactedText}</span>
                </div>
                <button class="btn btn-outline-primary btn-sm w-100" id="tip-compact-btn" ${status.isCompacting ? 'disabled' : ''}>
                    <i class="bi bi-scissors me-1"></i> ${status.isCompacting ? this.t('Compacting...') : this.t('Compact Conversation')}
                </button>
            `;

            container.querySelector('#tip-compact-btn')?.addEventListener('click', async () => {
                const btn = container.querySelector('#tip-compact-btn');
                if (btn) {
                    btn.disabled = true;
                    btn.innerHTML = `<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Compacting...`;
                }
                try {
                    this.appClient.notifier.showProgress({ message: 'Triggering compaction...' });
                    const res = await this.appClient.rpcClient.call('AiRpc.compactConversation', {
                        agentName,
                        threadId: this.thread._id
                    });
                    this.appClient.notifier.hideProgress();
                    if (res && res.success) {
                        this.appClient.notifier.success('Compaction completed successfully.');
                    } else {
                        this.appClient.notifier.warn('Compaction skipped or deferred.');
                    }
                    await this._loadMemoryStatus();
                } catch (e) {
                    this.appClient.notifier.hideProgress();
                    this.appClient.notifier.error(`Compaction failed: ${e.message}`);
                    await this._loadMemoryStatus();
                }
            });

        } catch (e) {
            this.log.error('Failed to load memory status', e);
            container.style.display = 'none';
        }
    }

    async _saveSettings() {
        const groupName = this.container.querySelector('#tip-gname')?.value.trim();
        const aiResponseMode = this.container.querySelector('#tip-aimode')?.value;
        try {
            await this.appClient.rpcClient.call('ThreadRpc.update', {
                _id: this.thread._id, groupName, aiResponseMode, title: groupName || this.thread.title,
            }, { projectId: this.workspace.currentProjectId });
            Object.assign(this.thread, { groupName, aiResponseMode });
            this.workspace.sidebarComponent?.updateThreadOptimistically({ _id: this.thread._id, groupName, aiResponseMode });
            this.appClient.notifier.success('Settings saved.');
        } catch (e) { this.appClient.notifier.error(`Failed: ${e.message}`); }
    }

    async _removeMember(member) {
        const name = this._resolveName(member);
        if (!await this.appClient.notifier.confirm(`Remove ${name}?`)) return;
        try {
            await this.appClient.rpcClient.call('ThreadRpc.removeMember', {
                threadId: this.thread._id, participantId: member.participantId,
            }, { projectId: this.workspace.currentProjectId });
            // Update local thread.members
            this.thread.members = this.thread.members.filter(m => m.participantId !== member.participantId);
            // Sync back to sidebar's allThreads cache so duplicate guard stays accurate
            const sidebarThread = this.workspace.sidebarComponent?.allThreads?.find(t => t._id === this.thread._id);
            if (sidebarThread) sidebarThread.members = [...this.thread.members];
            // Also sync WorkspaceChatArea's _currentThread
            if (this.workspace.chatAreaComponent) {
                this.workspace.chatAreaComponent._currentThread = this.thread;
                this.workspace.chatAreaComponent.renderHeader();
            }
            this._renderContent();
            this.appClient.notifier.success(`${name} removed.`);
        } catch (e) { this.appClient.notifier.error(`Failed: ${e.message}`); }
    }

    async _deleteThread() {
        if (!await this.appClient.notifier.confirm('Delete this conversation?')) return;
        try {
            await this.appClient.rpcClient.call('ThreadRpc.delete', { _id: this.thread._id }, { projectId: this.workspace.currentProjectId });
            this.close();
            if (this.workspace.sidebarComponent) {
                this.workspace.sidebarComponent.allThreads = this.workspace.sidebarComponent.allThreads.filter(t => t._id !== this.thread._id);
                this.workspace.sidebarComponent._applyFilters();
            }
            if (this.workspace.currentThreadId === this.thread._id) this.workspace.startNewThread();
        } catch (e) { this.appClient.notifier.error(`Failed: ${e.message}`); }
    }

    destroy() {
        this._backdrop?.remove();
        super.destroy();
    }
}
